import { Spinner } from "@nextui-org/react";
import { useCallback, useEffect, useState } from "react";
import { apigetallCurrentaffairs } from "../../../admin/shared/services/apiCurrentaffairs/apicurrentaffairs";
import { Link, useNavigate, useParams } from "react-router-dom";

export function MonthlyCurrentAffairsDetail() {
    const [loading, setLoading] = useState(true);
    const [affairs, setAffairs] = useState([]);
    const [month, setMonth] = useState("");
    const navigate = useNavigate();
    const { monthParam } = useParams();
    
    const fetchMonthAffairs = useCallback(async () => {
        if (!monthParam) return;
        
        const decodedMonth = decodeURIComponent(monthParam);
        setMonth(decodedMonth);
        setLoading(true);
        
        try {
         
            const res = await apigetallCurrentaffairs({ first: 0, rows: 1000 });
            const data = res?.resdata || [];
        
            const filteredAffairs = data.filter(item => {
                const date = new Date(item.createdAt);
                const itemMonthYear = `${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`;
                return itemMonthYear === decodedMonth;
            });
            
            setAffairs(filteredAffairs);
        } catch (error) {
            console.error('Error fetching affairs:', error);
        } finally {
            setLoading(false);
        }
    }, [monthParam]);

    useEffect(() => {
        fetchMonthAffairs();
    }, [fetchMonthAffairs]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <div className="max-w-[85rem] mx-auto py-5 px-4">
            <div className="flex items-center mb-6">
                <button onClick={() => navigate('/monthly-current-affairs')} className="mr-4">
                    <svg className="text-gray-600 size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="m15 18-6-6 6-6"/>
                    </svg>
                </button>
                <h1 className="text-3xl font-bold">{month} Current Affairs</h1>
            </div>

            {loading ? (
                <div className="flex items-center justify-center h-40">
                    <Spinner size="lg" color="primary" className="text-blue-500" />
                </div>
            ) : affairs.length === 0 ? (
                <div className="p-4 text-center bg-gray-100 rounded-lg">
                    <p>No current affairs available for {month}</p>
                </div>
            ) : (
                <>
                    <div className="mb-6">
                        <span className="px-3 py-1 text-sm bg-blue-100 rounded-full">
                            <span className="font-medium text-blue-800">{affairs.length} affairs</span>
                        </span>
                    </div>
                    
                    <div className="space-y-6">
                        {affairs.map((item) => (
                            <div key={item._id} className="p-4 border rounded-lg shadow-sm">
                                <div className="items-start justify-between lg:flex">
                                    <div>
                                        <h3 className="text-xl font-semibold text-blue-700">{item.Title}</h3>
                                        
                                        <div className="mt-3 text-sm text-gray-500">
                                            <span className="mr-4">{formatDate(item.createdAt)}</span>
                                            <span className="px-2 py-1 text-blue-800 bg-blue-100 rounded-md">
                                                {item.Category}
                                            </span>
                                            <span className="px-2 py-1 ml-2 text-green-800 bg-green-100 rounded-md">{item.Current_Affair_Type}</span>
                                        </div>
                                    </div>
                                    <div className="mt-5 lg:mt-0">
                                        <Link to={`/current-affairs/${item._id}`} className="px-4 py-2 text-sm font-medium text-white rounded-md bg-regal-blue hover:bg-blue-700">
                                            Read More
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}